<template>
	<transition name="lightbox-fade">
		<div v-if="visible" class="lightbox-overlay" @click.self="close">
			<button type="button" class="lightbox-close" @click="close" aria-label="Close">&times;</button>
			<img class="lightbox-image" :src="src" :alt="alt" @click.stop />
		</div>
	</transition>
</template>

<script>
export default {
	name: 'ImageLightbox',
	props: {
		visible: { type: Boolean, default: false },
		src: { type: String, default: '' },
		alt: { type: String, default: '' },
	},
	watch: {
		visible(val) {
			if (val) {
				document.addEventListener('keydown', this.onKeydown);
				document.body.style.overflow = 'hidden';
			} else {
				document.removeEventListener('keydown', this.onKeydown);
				document.body.style.overflow = '';
			}
		},
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeydown);
		document.body.style.overflow = '';
	},
	methods: {
		close() {
			this.$emit('close');
		},
		onKeydown(e) {
			if (e.key === 'Escape') this.close();
		},
	},
};
</script>

<style scoped>
.lightbox-overlay {
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.75);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
	cursor: zoom-out;
}
.lightbox-image {
	max-width: 90vw;
	max-height: 90vh;
	object-fit: contain;
	cursor: default;
	box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
}
.lightbox-close {
	position: absolute;
	top: 16px;
	right: 16px;
	width: 36px;
	height: 36px;
	border-radius: 50%;
	border: none;
	background: rgba(255, 255, 255, 0.9);
	color: #333;
	font-size: 22px;
	line-height: 1;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 0;
}
.lightbox-close:hover {
	background: #fff;
}
.lightbox-fade-enter-active,
.lightbox-fade-leave-active {
	transition: opacity 0.18s ease;
}
.lightbox-fade-enter,
.lightbox-fade-leave-to {
	opacity: 0;
}
</style>
